module.exports = __webpack_public_path__ + "static/img/audio-logo.66424e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio-logo.png
// module id = nRHJ
// module chunks = 0